import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import msal, { loginRequest, clearInteractionProgress } from 'lib/msal';
import { appInsights, getEnhancedLogLevel } from 'lib/appInsights';
import { Spinner } from 'UI';

var Auth = /*#__PURE__*/function (_Component) {
  _inherits(Auth, _Component);

  var _super = _createSuper(Auth);

  function Auth(props) {
    var _this;

    _classCallCheck(this, Auth);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getParameterByName", function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    });

    _defineProperty(_assertThisInitialized(_this), "runLogin", function () {
      var request = {
        redirectUri: window.location.origin + '/authenticate/callback?platform=' + _this.getParameterByName('platform'),
        scopes: ["openid", "profile", "offline_access", "user.read"],
        prompt: 'select_account'
      };

      if (_this.getParameterByName('scopes') != null) {
        var scopeParam = decodeURIComponent(_this.getParameterByName('scopes'));
        var scopes = scopeParam.split(';');
        request.scopes = scopes;
      }

      if (_this.getParameterByName('prompt') === "admin_consent") {
        request.prompt = 'consent';
        request.scopes = ["https://graph.microsoft.com/.default"];
      }

      if (_this.getParameterByName('state') != null) {
        request.state = decodeURIComponent(_this.getParameterByName('state'));
      }

      if (_this.getParameterByName('extraQueryParameters') != null) {
        request.extraQueryParameters = decodeURIComponent(_this.getParameterByName('extraQueryParameters'));
      }

      if (_this.getParameterByName('claims') != null) {
        request.claims = decodeURIComponent(_this.getParameterByName('claims'));
      }

      if (_this.getParameterByName('login_hint') != null) {
        request.loginHint = decodeURIComponent(_this.getParameterByName('login_hint'));
      }

      clearInteractionProgress();
      msal.loginRedirect(request);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      setTimeout(function () {
        _this.setState({
          showSession: true
        });
      }, 1000 * 5);

      _this.runLogin();
    });

    _this.state = {
      showSession: false
    };
    return _this;
  }

  _createClass(Auth, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }), this.state.showSession ? /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'var(--color--meta)'
        }
      }, "Session ID: ", localStorage.getItem('hsid')) : null);
    }
  }]);

  return Auth;
}(Component);

export { Auth as default };